import { globalAlertType } from '@/constants/global';
const state = {
    open: false,
    alertType: globalAlertType.ALERT,
    headerTitle: '',
    bodyContent: '',
    bodyContentHtml: '',
    selectedItem: '',
    // 컨펌 버튼 설정
    btnConfig: [],
    resolve: () => { },
};
export default state;
